import * as React from 'react';
import {Helmet} from 'react-helmet';
import {toast} from 'react-toastify';
import {useRoute} from 'react-router5';
import {createExercise} from 'api/exercise/requests';
import {ExerciseBuilder} from 'components/ExerciseBuilder';
import validateResponse from 'helpers/validate-response';
import isError from 'helpers/isError';
import styled from 'styled-components';

export const PageContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  box-sizing: border-box;
`;

/**
 * Create exercise page.
 * @return {React.ReactElement}
 * @constructor
 */
export default function CreateExercise(): React.ReactElement {
  const {router} = useRoute();
  return (
    <React.Fragment>
      <Helmet>
        <title>FitPlace / Создать упражнение</title>
      </Helmet>
      <PageContentContainer>
        <ExerciseBuilder
          onCreate={(exercise) => (
            createExercise(exercise).then((response) => {
              validateResponse(response);

              if (response && !isError(response)) {
                toast.success('Упражнение создано');
                router.navigate('exercises');
              }
            })
          )}
        />
      </PageContentContainer>
    </React.Fragment>
  );
}
